<template>
  <div class="portal-body">
      <header-portal></header-portal>
    <v-content class="content-top" v-if="isPrincipal">
      <v-layout class="row">
        <!-- <div class="row"> -->
          <div class="column-left">
              <span class="text-huge">DJBR</span>
          </div>
          <div class="column-right">
              <div class="text-big">DECLARACIÓN JURADA</div>
              <br>
              <div class="text-big">DE BIENES Y RENTAS</div>
          </div>
        <!-- </div>  -->
      </v-layout>
      <div class="portal-background-opacity">
        <v-container grid-list-md text-xs-center>
        <v-layout class="padding mt-0" row wrap align-center justify-center>
          <v-flex v-if="boton_digital === true">
            <v-btn class="tamanioBoton" color="primary" :loading="loading" :disabled="loading" dark large @click="authenticate(), loader = 'loading'">
              <b>Declaración Jurada Digital</b>&nbsp;
              <v-icon right dark>touch_app</v-icon>
              <template v-slot:loader>
                <span>Redirigiendo...</span>
              </template>
            </v-btn>
          </v-flex>
          <v-flex v-if="boton_tradicional === true">
            <v-speed-dial
              direction="bottom"
              transition="slide-y-transition"
            >
              <template v-slot:activator>
                <v-btn
                  class="tamanioBoton"
                  color="primary"
                  dark
                  large
                >
                  <b>Declaración Jurada Tradicional</b>&nbsp;
                  <v-icon right dark>touch_app</v-icon>
                </v-btn>
              </template>
               <login-djbr></login-djbr>
               <login-tarjeta></login-tarjeta>
            </v-speed-dial>
          </v-flex>
        </v-layout>
        </v-container>
        <v-layout class="padding" row wrap>
        <v-flex xs12 md3 sm6 class="padding-space">
          <v-speed-dial
            direction="top"
            transition="slide-y-transition">
            <template v-slot:activator>
              <div class="centered">
                <v-layout wrap>
                  <v-flex md12>
                    <v-btn color="transparent" fab large>
                      <v-icon
                        size="100"
                        color="white"
                      >
                        done_all
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <br>
                <v-layout wrap>
                  <v-flex md12>
                    <p class="padding-label" style="color:white;">
                      <b><br>Comprobación de<br> Certificados</b>
                    </p>
                  </v-flex>
                </v-layout>
              </div>
            </template>
            <comprobacion></comprobacion>
            <comprobacionFir></comprobacionFir>
          </v-speed-dial>
        </v-flex>
        <v-flex xs12 md3 sm6 class="padding-space">
          <verificacion></verificacion>
        </v-flex>
        <v-flex xs12 md3 sm6 class="padding-space">
          <resumen></resumen>
        </v-flex>
        <v-flex xs12 md3 sm6 class="padding-space">
          <div class="centered">
            <v-layout wrap>
              <v-flex md12>
                <v-btn color="transparent" fab large @click="$root.$emit('onOpcionPortal', 'base-legal'), $root.$emit('onOpcionBaseLegal')">
                  <v-icon
                    size="100"
                    color="white"
                    >library_books
                  </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <br>
            <v-layout wrap>
              <v-flex md12>
                <p class="padding-label" style="color:white;">
                  <br><b>Base legal</b>
                </p>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        </v-layout>
      </div>
      <!-- <v-layout wrap justify-center align-center class="pr-1">
        <v-img max-width="435px" min-width="60px" :src="require('@/assets/images/cge_logo.png')"></v-img>
      </v-layout> -->
    </v-content>
    <preguntas-frecuentes v-if="isPreguntas"/>
    <informacion v-if="isInformacion"/>
    <contacto v-if="isContacto"/>
    <base-legal v-if="isBaseLegal"/>
    <manuales v-if="isManuales"/>
  <v-footer
    :fixed="false"
    height="40"
    app
    dark
    color="gray"
    padless
    class="footer"
  >
    <v-layout align-center justify-center>
      <v-flex class="text-xs-center">
        <strong>{{ new Date().getFullYear() }} — Contraloría General del Estado</strong>
      </v-flex>
    </v-layout>
  </v-footer>
  <v-dialog v-model="dialogComunicado" persistent max-width="800">
    <v-card>
      <v-card-text>
        <v-card-title class="justify-center">
          <h3 class="mt-0" style="color: #01579B;"><strong>COMUNICADO</strong></h3>
        </v-card-title>
        <hr class="ma-1" color="#34699a">
        <p style="text-align: justify;">
          <br/>La Contraloría General del Estado (CGE) comunica que, debido a inconvenientes en la plataforma de Ciudadanía Digital de la AGETIC, se suspende temporalmente  el acceso para la presentación de las Declaraciones Juradas de Bienes y Rentas en la modalidad digital. <br><br>
          <ul><li>Los declarantes que iniciaron su Declaración Jurada de Bienes y Rentas con Ciudadanía Digital y no concluyeron la misma, podrán realizarla en la modalidad tradicional (física), <a href="../../static/docs/guia.pdf" target="_blank">ver guía.</a></li></ul>
        </p>
        <p style="text-align: end;">La Paz, 23 de octubre de 2024</p>
      </v-card-text> 
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dialogComunicado = false">CERRAR</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogComunicadoSinPersistente" max-width="800">
    <v-card>
      <v-card-text>
        <v-card-title class="justify-center">
          <h3 class="mt-0" style="color: #01579B;"><strong>ATENCIÓN</strong></h3>
        </v-card-title>
        <hr class="ma-1" color="#34699a">
        <p style="text-align: justify;">
          <br/>Para verificar la veracidad de un certificado digital el QR le redireccionará al Sistema de Declaraciones Juradas de Bienes y Rentas de la CGE.
        </p>
      </v-card-text> 
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dialogComunicadoSinPersistente = false">CERRAR</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogImagenComunicado" persistent max-width="900" >
    <v-card> 
       <img :src="require('@/assets/images/comunicado-001-2024.png')" alt="" width="100%" @click.stop="dialogImagenComunicado=false">
       <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogImagenComunicado = false">CERRAR</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogImagen" max-width="85vw" >
    <v-card>
       <img :src="require('@/assets/images/PASOS_CIUDADANIA.jpeg')" alt="" width="100%" @click.stop="dialogImagen=false">
       <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogImagen = false">CERRAR</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import HeaderPortal from '@/components/djbrd/headerPortal.vue';
import Verificacion from '@/components/portal/verificacion.vue';
import Resumen from '@/components/portal/resumen.vue';
import Comprobacion from '@/components/portal/comprobacion.vue';
import ComprobacionFir from '@/components/portal/comprobacionFir.vue';
import BaseLegal from '@/components/portal/baseLegal.vue';
import Auth from '../admin/auth/mixins/auth.js';
import LoginDjbr from '@/components/portal/login/LoginDjbr.vue';
import LoginTarjeta from '@/components/portal/login/LoginTarjeta.vue';
import PreguntasFrecuentes from '@/components/djbrd/PreguntasFrecuentes';
import Informacion from '@/components/djbrd/Informacion';
import Contacto from '@/components/djbrd/Contacto';
import Manuales from '@/components/djbrd/Manuales';
export default {
  mixins: [ Auth ],
  components: {
    HeaderPortal,
    Verificacion,
    Resumen,
    Comprobacion,
    ComprobacionFir,
    BaseLegal,
    LoginDjbr,
    LoginTarjeta,
    PreguntasFrecuentes,
    Informacion,
    Contacto,
    Manuales
  },
  created () {
    if (this.$storage.existUser()) {
      this.logout();
    }
    this.verificarBrowser();
  },
  data: () => ({
    boton_digital: process.env.BOTON_DIGITAL,
    boton_tradicional: process.env.BOTON_TRADICIONAL,
    loading: false,
    activeBtn: 1,
    repetidosModal: true,
    isPrincipal: true,
    isPreguntas: false,
    isInformacion: false,
    isContacto: false,
    isBaseLegal: false,
    isManuales: false,
    dialogComunicado: false,
    dialogImagenComunicado: false,
    dialogImagen: false,
    dialogComunicadoSinPersistente: true
  }),
  mounted () {
    this.$root.$on('onOpcionPortal', (value) => {
      this.cambiarOpcionPortal(value);
    });
  },
  methods: {
    authenticate () {
      this.loading = true;
      setTimeout(() => {
        this.getCode();
        this.loading = false;
      }, 2000);
    },
    /* eslint-disable */
    verificarBrowser () {
      navigator.sayswho = (function () {
        let ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
          tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
          if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(' ');
      })();
      if (navigator.sayswho.indexOf('Opera') !== -1 || navigator.sayswho.indexOf('IE') !== -1 || navigator.sayswho.indexOf('Safari 9') !== -1) {
        this.$message['warning']('Navegador no soportado para el sistema, debe utilizar Firefox o Chrome para que el sistema funcione correctamente');
      }
    },
    cambiarOpcionPortal (value) {
      switch (value) {
        case 'principal':
          this.isPrincipal = true;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'preguntas':
          this.isPrincipal = false;
          this.isPreguntas = true;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'informacion':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = true;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'contacto':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = true;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'base-legal':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = true;
          this.isManuales = false;
          break;
        case 'manuales':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = true;
          break;
        default:
          break;
      }
    }
    /* eslint-disable */
  }
};
</script>

<style lang='scss'>
.footer {
  font-size: 12px;
}
.padding {
  padding-top: 2.0%;
  padding-right: 10px;
  padding-bottom: 5%;
  padding-left: 10px;
}

.pdf-view .pdf-view-actions .pdf-view-buttons .visible {
  visibility: hidden !important;
}
body .application main .main {
    padding: 0px 0px;
}
.portal-body {
  background-image:  linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.11),
      rgba(0, 0, 0, 0.11)
    ), url(../../assets/images/home.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  height: fit-content;
}
.text-huge{
  color: white;
  font-size: 120px;
  font-weight: 100;
  font-family: Arial, Helvetica, sans-serif;
  display: inline-block;
}
.text-big{
  color: white;
  font-size: 40px;
  font-weight: 100;
  font-family: Arial, Helvetica, sans-serif;
  display: inline-block;
}
.text-medium{
  color: white;
  font-size: 20px;
}
.icono{
  color: white;
  size: 120px;
}
.column-left {
  float: left;
  width: 30%;
  text-align: right;
}
.column-right {
  float: left;
  width: 70%;
  text-align: left;
  padding-top:42px;
  line-height: normal;
}
.row:after {
  content: "";
  // display: table;
  clear: both;
  display:table-cell;
  vertical-align:middle;
}
.portal-background-opacity{
  background-color: #19345b;
  opacity: 0.8;
  background-size: auto;
}
@media (max-width: 900px) {
  .padding {
    padding-top: 10%;
    padding-right: 10px;
    padding-bottom: 5%;
    padding-left: 10px;
  }
  .text-big{
    color: white;
    font-size: 30px;
    font-weight: 100;
    font-family: Arial, Helvetica, sans-serif;
  }
  .text-huge{
    color: white;
    font-weight: 100;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 80px;
  }
  .text-medium{
    color: white;
    font-size: 12px;
  }
  .column-right {
  float: left;
  width: 70%;
  text-align: left;
  padding-top:23px;
  line-height: normal;
  }
}
@media (max-width: 600px) {
  .padding {
    padding-top: 10%;
    padding-right: 10px;
    padding-bottom: 20%;
    padding-left: 10px;
  }
  .text-big{
    color: white;
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    font-weight: 100;
    font-family: Arial, Helvetica, sans-serif;
  }
  .text-huge{
    color: white;
    font-weight: 100;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 45px;
  }
  .text-medium{
    color: white;
    font-size: 12px;
  }
  .column-right {
  float: left;
  width: 70%;
  text-align: left;
  padding-top:8px;
  line-height: normal;
  }
}
.image {
  width: 281px;
  height: 55px;
  background-image: url(../../assets/images/logo.png);
  float: inherit;
}
/*
.padding-space {
  padding-top: 10px;
  padding-bottom: 10px;
}
*/
.opcion-declarar {
  padding-top: 30px;
}
.content-top {
  padding: 64px 0px 48px !important;
}
@media (max-width: 1300px) {
  .content-top {
    padding: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/djbrd/portal.vue